export default __webpack_public_path__ + "static/media/icon-up-and-down.378a49fe.svg";